import { Controller, useFormContext } from "react-hook-form";
import { FormInvoiceType } from "../types";
import { Button, Input, Modal } from "components";
import { TbInfoCircle } from "react-icons/tb";
import CustomerOrderDetail from "../../CustomerOrder/components/Detail";
import { useToggle } from "utils";

export function LinkToSalesOrder(): JSX.Element {
    const { control, getValues } = useFormContext<FormInvoiceType>()
    const salesOrderId = getValues("sales_order_id")

    return (
        <section className="flex items-end">
            <section className="grow">
                <Controller
                    control={control}
                    name="link"
                    render={({ field }) => (
                        <Input 
                            disabled 
                            label="LINK" 
                            defaultValue={field.value} 
                        />
                    )}
                />
            </section>

            <DetailSection
                sales_order_id={salesOrderId?.toString()}
            />
        </section>
    )
}

function DetailSection(props: {
    sales_order_id?: string
}) {
    const { isActive, toggle } = useToggle(false)

    return (
        <>
            <Button
                type="button"
                color="primary"
                onClick={toggle}
            >
                <TbInfoCircle />
            </Button>

            {isActive && (
                <Modal
                    isOpen
                    title="SALES ORDER DETAIL"
                    closeModal={toggle}
                >
                    <Modal.Body>
                        <CustomerOrderDetail
                            sales_order_id={props.sales_order_id!.toString()}
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    )
}